import { __decorate } from "tslib";
import SimpleTable from '@/components/SimpleTable.vue';
import ModalMixin from '@/mixins/modal-mixin';
import debounce from 'lodash/debounce';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { mapActions, mapGetters, mapState } from 'vuex';
import ServiceModal from '../ServiceModal.vue';
import Navigation from '../Services/Navigation.vue';
import TreatmentModal from '../TreatmentModal.vue';
import PrintTreatmentsModal from "./PrintTreatmentsModal.vue";
let Services = class Services extends Mixins(ModalMixin) {
    serviceId;
    findTreatmentInStore;
    findServicesInStore;
    patchService;
    fetchService;
    fetchTreatments;
    deleteTreatment;
    areTreatmentsLoading;
    areServicesLoading;
    serviceQuery = null;
    query = null;
    sort = 'code';
    order = 1;
    data() {
        return {
            model: {},
            items: [],
        };
    }
    get columns() {
        return [
            {
                label: '',
                name: 'public',
                width: '1px',
                field(item) {
                    if (item.public)
                        return '<i class="fe fe-check"></i>';
                }
            },
            {
                label: 'Code',
                name: 'code',
                sortable: true,
                subtitle: (item) => {
                    return item.shortcode;
                },
            },
            {
                label: 'Name',
                name: 'label',
                field(item) {
                    let result = '';
                    if (item.bundle && item.bundle.length)
                        result = '<i class="fe fe-package" ></i> ';
                    return result + item.label;
                },
                subtitle: (item) => {
                    if (item.service) {
                        return item.service.label;
                    }
                    else {
                        return 'N/A';
                    }
                },
            },
            {
                label: 'Price',
                name: 'price',
                money: true,
            },
            {
                label: 'Duration',
                name: 'duration',
                width: '100px',
                field: (item) => {
                    if (item.duration)
                        return item.duration.toString() + this.$t('min');
                    return '-';
                },
                subtitle: (item) => {
                    if (item.bufferDuration)
                        return item.bufferDuration.toString() + this.$t('min');
                },
            },
        ];
    }
    get serviceParams() {
        const query = {
            $limit: 10000,
            $sort: { priority: 1 }
        };
        if (this.serviceQuery) {
            query.$or = [
                { label: { $regex: this.serviceQuery, $options: "i" } },
            ];
        }
        return { query };
    }
    get params() {
        const query = {
            $limit: 1000,
            $sort: {
                code: 1,
            },
        };
        if (this.query) {
            query.$or = [
                { label: { $regex: this.query, $options: "i" } },
            ];
        }
        if (this.serviceId) {
            query.serviceId = this.serviceId;
        }
        if (this.sort) {
            query.$sort = {
                [this.sort]: this.order
            };
        }
        return { query };
    }
    get treatments() {
        const query = { ...this.params.query, _id: { $ne: 'temp' } };
        return this.findTreatmentInStore({ query }).data;
    }
    get services() {
        return this.findServicesInStore(this.serviceParams).data;
    }
    set services(value) {
        if (!window.confirm(this.$t('Do you confirm ?').toString()))
            return;
        value.forEach((item, index) => {
            item.priority = index;
            this.patchService([item._id, item, {}]);
        });
    }
    findServices(params) {
        debounce(() => this.fetchService(params), 400)();
    }
    queryTreatments(params) {
        debounce(() => this.fetchTreatments(params), 400)();
    }
    setSort(field, order) {
        this.sort = field;
        this.order = order;
    }
    openPrintModal() {
        this.openModal({ id: 'PrintTreatmentModal' });
    }
    openTreatmentModal(item) {
        const { Treatment } = this.$FeathersVuex;
        new Treatment({
            _id: 'temp',
            model: item
        });
        this.openModal({ id: 'treatmentModal' });
    }
    deleteItem(item) {
        this.deleteTreatment(item._id).then(() => {
            this.$toasted.global.success({
                message: this.$t('Treatment has been deleted')
            });
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], Services.prototype, "serviceId", void 0);
__decorate([
    Watch('serviceParams')
], Services.prototype, "findServices", null);
__decorate([
    Watch('params')
], Services.prototype, "queryTreatments", null);
Services = __decorate([
    Component({
        components: {
            PrintTreatmentsModal,
            Navigation,
            SimpleTable,
            ServiceModal,
            TreatmentModal,
            draggable
        },
        computed: {
            ...mapGetters('service', { findServicesInStore: 'find' }),
            ...mapGetters('treatment', { findTreatmentInStore: 'find' }),
            ...mapState('service', { areServicesLoading: 'isFindPending' }),
            ...mapState('treatment', { areTreatmentsLoading: 'isFindPending' }),
        },
        methods: {
            ...mapActions('service', {
                fetchServices: 'find',
                removeService: 'remove',
                createService: 'create',
                patchService: 'patch'
            }),
            ...mapActions('treatment', {
                fetchTreatments: 'find',
                deleteTreatment: 'remove'
            }),
        }
    })
], Services);
export default Services;
